import { render, staticRenderFns } from "./PermissionsAdmin.vue?vue&type=template&id=077ac5cc&"
import script from "./PermissionsAdmin.vue?vue&type=script&lang=js&"
export * from "./PermissionsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports